import { boot } from 'quasar/wrappers';
import { HandledError } from 'src/apps/cloud/utils/classes/WS.class';
import { useDialogStore } from 'src/apps/cloud/stores/dialog.ts';
export default boot(({ app, store }) => {
    const dialogStore = useDialogStore(store);
    const showHandledError = (message) => {
        dialogStore.set({
            show: true,
            title: message,
            ok: {
                color: 'negative'
            }
        });
    };
    window.addEventListener('unhandledrejection', (event) => {
        if (event.reason instanceof HandledError) {
            event.preventDefault();
            event.stopImmediatePropagation?.();
            showHandledError(event.reason.message);
            console.warn('Handled API Error:', event.reason.message);
        }
    }, { capture: true });
    window.addEventListener('error', (event) => {
        if (event.error instanceof HandledError) {
            event.preventDefault();
            event.stopImmediatePropagation?.();
            showHandledError(event.error.message);
            console.warn('Handled API Error:', event.error.message);
        }
    }, { capture: true });
    const originalErrorHandler = app.config.errorHandler;
    app.config.errorHandler = (err, instance, info) => {
        if (err instanceof HandledError) {
            showHandledError(err.message);
            console.warn('Handled API Error (Vue handler):', err.message);
            return;
        }
        if (typeof originalErrorHandler === 'function') {
            originalErrorHandler(err, instance, info);
        }
        else {
            console.error(err);
        }
    };
});
